import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Home from "../views/home";
import Template from "../views/template";
import History from "../views/history";
import Judge from "../views/judge";
import JudgeDetail from "../views/judge/detail";
import HistoryDetail from "../views/history/detail";
import Login from "../views/login";
import PlayerDetail from "../views/player/detail";
import PersonalCases from "../views/player/personalCases";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      // {
      //   path: "/judge",
      //   element: <Judge />,
      // },
      {
        path: "/template",
        element: <Template />,
      },
      {
        path: "/history",
        element: <History />,
      },
      // {
      //   path: "/judge/detail",
      //   element: <JudgeDetail />,
      // },
      {
        path: "/history/detail",
        element: <HistoryDetail />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/player/detail",
        element: <PlayerDetail />,
      },
      {
        path: "/player/personalCases",
        element: <PersonalCases />,
      },
    ],
  },
]);

export default router;
